function IconEntryRevival({
  width = 18,
  height = 14,
  color = '#495057',
}: { width?: number; height?: number; color?: string } = {}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00129 0.0566606C12.176 0.0568537 15.1404 0.971548 17.6409 2.55178C17.9125 2.72337 18.0496 3.0458 17.9847 3.36037L15.9271 13.3272C15.8529 13.6853 15.537 13.9424 15.1712 13.9424H2.82941C2.46362 13.9424 2.14768 13.6853 2.07355 13.3272L0.0159351 3.3594C-0.0489839 3.04483 0.0881659 2.72239 0.359685 2.5508C2.94527 0.916826 5.94268 0.0518511 9.00129 0.0566606ZM10.345 4.11525C10.0351 4.11526 9.76625 4.19362 9.5384 4.34963C9.31265 4.50355 9.131 4.70661 8.99347 4.959C8.85804 4.70868 8.67628 4.50561 8.44855 4.34963C8.2228 4.19366 7.95472 4.11529 7.64484 4.11525C7.39448 4.11525 7.16023 4.16248 6.94269 4.25686C6.72715 4.34923 6.53573 4.48276 6.36945 4.65725C6.20529 4.8317 6.07616 5.03921 5.98176 5.27932C5.88938 5.51949 5.84308 5.78567 5.84308 6.07717C5.84313 6.51637 5.9598 6.95271 6.19172 7.38576C6.42361 7.81662 6.74967 8.23625 7.17023 8.64455C7.59303 9.05093 8.08992 9.43917 8.66047 9.80861C8.71587 9.84555 8.77469 9.87851 8.83625 9.90725C8.89783 9.93804 8.95037 9.95315 8.99347 9.95315C9.03859 9.9531 9.09125 9.938 9.1507 9.90725C9.21216 9.87855 9.27204 9.84549 9.32941 9.80861C9.89784 9.4392 10.3921 9.05089 10.8128 8.64455C11.2356 8.23613 11.5633 7.81676 11.7952 7.38576C12.0271 6.95271 12.1428 6.51637 12.1429 6.07717C12.1429 5.78567 12.0957 5.51949 12.0013 5.27932C11.9089 5.03922 11.7807 4.83169 11.6165 4.65725C11.4524 4.48292 11.2608 4.34919 11.0413 4.25686C10.8237 4.16243 10.5914 4.11525 10.345 4.11525Z"
        fill={color}
      />
    </svg>
  );
}

IconEntryRevival.displayName = 'IconEntryRevival';

export { IconEntryRevival };
